import React from 'react';

const RouteWithNotFound: React.FC  = () => {
	return (
		<div>
 			Error 404!. Not found.
 		</div>
	);
};

export default RouteWithNotFound;
